import { StaticImage } from 'gatsby-plugin-image';
import moment from 'moment';
import React, { useContext } from 'react';
import { Chip } from '@/features/details/shared';
import { HSpace } from '@/components/spacing';
import { Opt } from '@/features/details/date-pick/quick-range-select';
import { DatePickerContext } from '@/features/details/date-pick/context';

type Props = {
  onClick: () => void;
};
export const DatePickerChip = React.forwardRef(({ onClick }: Props, ref) => {
  const { startDate, endDate, step, version } = useContext(DatePickerContext);
  let message = ``;
  switch (step) {
    case Opt.Current:
      message = `Latest Version:`;
      break;
    case Opt.CustomRange:
      message = `Custom:`;
      break;
    case Opt.LastWeek:
      message = `Last Week:`;
      break;
    case Opt.LastMonth:
      message = `Last Month:`;
      break;
    case Opt.Today:
      message = `Today:`;
      break;
    case Opt.Yesterday:
      message = `Yesterday:`;
      break;
    case Opt.OverAll:
      message = `Overall:`;
      break;
    case Opt.PreviousVersion:
      if (version?.isCurrent) {
        message = `Latest Version:`;
      } else {
        message = `Version ${version?.version ? `(${version?.version})` : ``}:`;
      }
      break;
    default:
  }
  const marginRight = `1rem`;
  return (
    <Chip onClick={onClick} ref={ref}>
      <StaticImage
        style={{ marginRight }}
        src="calendar.svg"
        alt="calendar"
        placeholder="none"
        loading="eager"
        formats={[`png`, `webp`]}
        height={10}
      />
      {message} {formatDuration(startDate, endDate)}
      <DownIcon />
    </Chip>
  );
});

export function DownIcon() {
  return (
    <>
      <HSpace value={1.5} />
      <StaticImage
        src="../../../assets/down_arrow.svg"
        alt="end"
        placeholder="none"
        loading="eager"
        height={4}
      />
    </>
  );
}

export function formatDuration(
  startDater: Date | string,
  endDate: Date | string,
) {
  return (
    <>
      {moment(startDater)?.format(`  MMM D, YYYY`)}
      {` `}
      {` - `}
      {moment(endDate)?.format(`  MMM D, YYYY`)}
    </>
  );
}
